<template>
  <div>
    <!--<div class="form-group">
      <label>Durée (en toutes lettres)</label>
      <input type="text" placeholder="Exemple : 2 jours, 1 semaine, 5 heures, ..." name="duree" class="form-control" v-model="billing.duree"/>
    </div>-->
    <div class="form-group">
      <label>Nombres de personnes</label>
      <input type="text" placeholder="Exemple : de 2 à 5 personnes, ..." name="person_count" class="form-control" v-model="billing.person_count"/>
    </div>
    
      <!-- <p>Si votre activité nécessite une autorisation spéciale, veuillez renseigner les champs suivants :</p>
      <label>Origine de l'autorisation d'exercice </label><br /><input type="text" placeholder="agence de voyage, tout compris,..." name="origine_exercice" class="form-control" v-model="billing.origine_exercice" />
      <label>Numéro de l'autorisation d'exercice </label><br /><input type="text" name="num_autorisation" class="form-control" v-model="billing.num_autorisation" /> -->
  </div>
</template>

<script>
export default {

  name: 'billingActivity',
  props: ['oldbilling'],
  data () {
    return {
        billing: Object.assign({}, this.oldbilling)
    }
  }
}
</script>

